<template>
    <span class="wrapper">
        <div class="header-area">
            <NavBarDark></NavBarDark>
            <div class="message text-center"><h1 class="heading-white"><span>Learn tech courses and move ahead in your career!</span></h1>
                <b-button v-on:click="signUp" class="signup-btn"><b>BROWSE COURSES</b></b-button>
            </div>
        </div>
        <div class="description text-left">
            <div>
                <h1 class="heading">Practical learning is the best way to learn</h1>
                <div>At Product Planet we believe that every individual must get the chance to learn and seek more fulfilling 
                    career opportunities. Thus, it is our mission to help candidates learn and grow in their careers. 
                    You can learn the following at Product Planet </div><br><br>
                <h3 class="label-heading">Front-end Development (ReactJS)</h3>
                <div>Single Page Applications (SPAs) and component-based front-end frameworks are all the rage right now! 
                    Learn React JS through self-paced bite-sized interactive courses so you can prepare for your dream front-end job. Once you're ready challenge yourself with 
                    our React JS challenges.
                </div><br><br>
                <h3 class="label-heading">Front-end Development (VueJS)</h3>
                <div>VueJS is one of the most popular and fastest-growing front-end JavaScript frameworks. Learn the basics of Vue 
                    with our self-paced bite-sized interactive courses. Once you're ready, challenge yourself with our Vue JS challenges.
                </div><br><br>

                <h3 class="label-heading">Front-end Development (Modern Javascript)</h3>
                <div>Javascript is the language that powers the internet. Javascript is used today to power the frontend of websites 
                    with frameworks such as JQuery / React JS / VueJS / Angular along with NodeJS as the backend. NodeJS has taken the 
                    backend world by storm and is used extensively today.
                </div><br><br>

                <h3 class="label-heading">Mobile Development (React Native)</h3>
                <div>You have an app for everything today. Apps for food delivery, games, social network, banking, etc. are all around us. 
                    For many products, over 50% of their audience is on app vs web. React Native is a Javascript-based framework by Facebook
                     that converts Javascript into native Android or ios code, so it feels like a native app instead of a web app. <br>
                     We help you learn React Native so you don't miss the opportunity to work in your dream mobile development job!
                </div> <br><br> 
                
                <h3 class="label-heading">UI/UX Design</h3>
                <div>Learn important UI/UX Design concepts so you can be ready for a UI/UX job and grab your dream UI/UX opportunity. 
                    Once you have learned the concepts, take a UI/UX design assessment and see where you stand. 
                </div><br><br>

                <h3 class="label-heading">Data Science</h3>
                <div>Learn important Data Science concepts so you can be ready for a Data Science job and grab your dream Data Science opportunity. 
                    Once you have learned the concepts, take a Data Science assessment and see where you stand. 
                </div><br><br>

                <h3 class="label-heading">Product Management</h3>
                <div>Learn important UI/UX Design concepts so you can be ready for a Product Management job and grab your dream Product Management opportunity. 
                    Once you have learned the concepts, take a Product Management assessment and see where you stand. 
                </div><br><br>
                
            </div>
        </div>

        <div class="footer-component">
            <FooterDark></FooterDark>
        </div>
    </span>
    
</template>

<script>
import NavBarDark from '@/components/NavBarDark.vue'
import FooterDark from '@/components/FooterDark.vue'
import firebase from '../services/firebase'
import router from '../router'
import Typed from 'typed.js';
export default {
    name: 'LearnPage',
    components: {
        NavBarDark,
        FooterDark
    },
    mounted: function() {
      var typed = new Typed('.typed_element', {
          strings: ["Frontend Development", "Mobile Development", "UX Design", "UI Design"],
          smartBackspace: true,
          typeSpeed: 100,
          loop: true,
          loopCount: Infinity,
          showCursor: false
      });
    },
    methods: {
        signUp: function() {
            console.log("inside signUp vue function");
            router.push('/home');
        }
    }
}
</script>


<style scoped>

    .wrapper {
        font-family: Avenir;
    }

    .typed_element{
        color: white;
        font-size:1.65rem;
        font-weight: 500;
        color: #42f498;
    }
    .typed_static {
        color: white;
        font-size:1.65rem;
        font-weight: 500;
        color: #42f498;
    }

    .typed-cursor {
        color:lightgreen;
        margin-left: 5px;
        font-size:32px;
    }

    .signup-btn:hover {
        background-color:#f25792;
        color: #fff;
        border-color: #f25792;
    }

    .message {
        margin-top: 5%;
        margin-bottom: 5%;
    }

    .description {
        font-size: 1rem;
        margin-left: 12%;
        margin-right: 12%;
        margin-top: 4%;
        padding-bottom: 4%;
    }


    @media (min-width:600px){
        .signup-btn {
            background-color:#f25792;
            border-color:#f25792;
            color:#fff;
            font-size:0.8rem;
            cursor: pointer;
            border-radius: 60px;
            z-index: 9999;
            padding-top:1.5% !important;
            padding-bottom:1.5% !important;
            padding-left:1.4% !important;
            padding-right:1.4% !important;
            width: 14%;
        }
    }


    @media (max-width:599px) {
        .signup-btn {
            background-color:#f25792;
            border-color:#f25792;
            color:#fff;
            font-size:0.8rem;
            cursor: pointer;
            border-radius: 60px;
            z-index: 9999;
            padding-top:3% !important;
            padding-bottom:3% !important;
            padding-left:2.5% !important;
            padding-right:2.5% !important;
            margin-top: 6%;
            margin-bottom:6%;
            width: 30%;
        }
    }
   
    .gif-content {
        margin-left:0%; 
        margin-top:6%;
    }

    @media (max-width:576px) {
        .col {
            margin: auto;
        }

        .all-content {
            margin-bottom: 10%;
        }

        .gif-content {
            margin-left:0%; 
            margin-top:16%;
        }

        
    }
    
    .header-area {
        color:#fff;
        /*background:linear-gradient(80deg, #5751d1, #798bf2); */
        background:linear-gradient(100deg, #5751d1, #6d7edb);
        padding-bottom: 20px;
    }

    @media(max-width:576px) {
       .header-area {
            color:#fff;
            /*background:linear-gradient(80deg, #5751d1, #798bf2); */
            background:linear-gradient(100deg, #5751d1, #6d7edb);
            padding-bottom:40px;
        } 
    }

    .heading-white {
        font-size: 1.55rem !important;
        margin-top:3%;
        margin-bottom: 2%;
        font-weight: 400;  
    }

    .heading {
        font-size: 1.55rem !important;
        margin-top:3%;
        margin-bottom: 2%;
        font-weight: 400;  
        color: #333;
    }

    .label-heading {
        font-size: 1.25rem;
        margin-bottom: 1.3%;
        font-weight: 400;
        color: #333;
    }

</style>
